import * as React from 'react';
import { Conduit, Graft } from "./TriggerClasses";
import { MeasurmentThumbnail } from '../../Components/MeasurementThumbnail';
import { PreviewProcedureModel } from '../PreviewProcedureModel';
import { DataHelper } from '../../Helpers/DataHelper';
import { StudyModel } from '../StudyModel';
import { PreviewMeasurement } from '../PreviewMeasurement';

class CardiacSubwayMap extends React.Component < {
    CurrentItem : Graft,
    showsaves: boolean,
    showeditbutton: boolean,
    parentProcedure: PreviewProcedureModel,
    procedureType: string,
    studySelected: StudyModel, 
    dataHelper: DataHelper,
    showSelected: boolean,
    measurementAllocated?: (procedureType: string, timestep:string, procedureId: string, measurementId: string, graftId: string) => void,
    editGraftClicked? : (timestep:string, procedureId: string, graftId: string)=>void, 
    protocolSteps: string[]
}, {
    frequentUsedOpen: boolean,
}, any>
 {

    static defaultProps = {
        showsaves: false,
        showeditbutton: false,
        procedureType: "",
        parentProcedure: null,
        studySelected: null,
        dataHelper: null,
        showSelected: true,
        measurementAllocated: () => {},
        editGraftClicked: () => {}
      }

    constructor(props : any) {
        super(props);
        this.state = {
            frequentUsedOpen: false
        };
    }

    generateParkingSpace = (graftId: string, protocolSteps: string[]) : React.ReactElement => {




        if (!this.props.showsaves)
            return <></>

        let stepsForGraft: React.ReactElement[] = protocolSteps.map((stepName, stepIndex) => {
              let measurementsForGraft: PreviewMeasurement[] = [];
                if (this.props.parentProcedure)
                {

                    measurementsForGraft = this.props.parentProcedure.measurements.filter(m => {

                        //Get id of selected segment of graft
                        if (m.intuiGraft)
                        {
                            let GraftFound = Graft.recurseSelected(m.intuiGraft);
                            if (GraftFound.id === graftId)
                            {
                                if (!this.props.procedureType  || this.props.procedureType === m.performedProcedure || (!m.performedProcedure && this.props.procedureType === Object.keys(Graft.CardiacProcedureTypesLookup)[0]))
                                if (protocolSteps.length ===  1  || (m.performedProcedureStep && m.performedProcedureStep === stepName))
                                    return true;
                            }
                            
                        }
                        return false;
                    });
                    
                }

                let stepContainer: React.ReactElement = <div className="visual-graft-column visual-graft-saves-container">
                   
                 <div className="parkingSpaceContainer"><div className="parkingSpaceHolder" onDragLeave={(event)=>{
                            event.currentTarget.classList.remove("dragover");
                        }} onDragOver={(event)=>{
    
                            event.currentTarget.classList.add("dragover");
    
                        event.preventDefault();  // Allow drop
                        }} onDrop={(event) => {
                            
                            event.currentTarget.classList.remove("dragover");
                         event.preventDefault();
                         const id = event.dataTransfer.getData('text/plain');

                         //Find the measurement using id, clone the this.props.currentItem and then set selected to true on the child graft with id of this.columnContainerAllGraftIds[index] then set intui graft to the cloned graft.
                         if (this.props.parentProcedure && this.props.measurementAllocated)   
                            this.props.measurementAllocated(this.props.procedureType, stepName, this.props.parentProcedure.id, id, graftId);
                          //  this.props.measurementAllocated(stepIndex, vessel, this.props.parentProcedure.id, id, this.props.parentProcedure.sideUsed);
                             this.forceUpdate();
       
                            
                        }}  ><div className="parkingSpaceDrag">drag here</div><div className="parkedMeasurements">
                            {measurementsForGraft.map((measurementItem) => {
let ThumbIn = <MeasurmentThumbnail key={measurementItem.id} studySelected={this.props.studySelected} dataHelper={this.props.dataHelper} procedureId={this.props.parentProcedure.id} rowData={measurementItem} detailed={false} expanded={()=>{}} />;
 return <div className='allocatedMeasurement'>{ThumbIn}
                                        <button className='allocatedMeasurementDelete' title='Remove from location' onClick={()=>{
                                            if (this.props.parentProcedure && this.props.measurementAllocated)
                                             this.props.measurementAllocated(this.props.procedureType, stepName, this.props.parentProcedure.id, measurementItem.id, "remove");
                                             this.forceUpdate();
                                        }}>X</button></div>;

                                
                            })
                            }</div></div></div>
            </div>;

            return <span className={stepName}><div>{stepContainer}</div></span>;
        });
      return <>{stepsForGraft}</>;
    }

    graftBoxes: React.ReactElement[] = [];

    recurseAddingBoxes = (childGraft: Graft , index: number , parentConduit: string, protocolSteps: string[]) => {
        
        let currentConduit = childGraft.conduit;
        if (!currentConduit)
            currentConduit = parentConduit as Conduit;

        if (childGraft.type === "PreGraft") 
        {
            this.graftBoxes.push(<tr className={"child"+index}><td className="td1"></td><td className="td2">
          <button className={"subwayLocation "  }>{childGraft.title}</button>
        </td>
        <td className="td3">
          {this.generateParkingSpace(childGraft.id as string, protocolSteps)}
        </td>
      </tr>);
            return;
        }
        let conduitColor = "";
        if (currentConduit === Conduit.SVG)
            conduitColor = "svg";
        else if (currentConduit === Conduit.RA)
            conduitColor = "ra";
         else if (currentConduit === Conduit.GEA)
            conduitColor = "gea";
         let isTopLevel = childGraft.type === "Source" ;
         if (isTopLevel )
         {
            this.graftBoxes.push(<tr className={"child0 " + conduitColor}><td className="td1"></td>
        <td className="td2">
          <button className={"subwayLocation " + conduitColor + " " + (this.props.showSelected && childGraft.selected ? "selected" : "")}>{childGraft.title}</button>
        </td>
        <td className="td3">
          {this.generateParkingSpace(childGraft.id as string, protocolSteps)}
        </td>
      </tr>);
       index++;
         }
         else
         {
            let seqY = "";
            if (index !== 1)
            {
                seqY = childGraft.sequential ? "seq" : "y";
            }
            this.graftBoxes.push(<tr className={"child"+index  + " " + seqY + " " + conduitColor}><td className="td1"></td>
        <td className="td2">
          <button className={"subwayLocation " + (this.props.showSelected && childGraft.selected ? "selected" : "") }>{childGraft.name}</button>
        </td>
        <td className="td3">
          {this.generateParkingSpace(childGraft.id as string, protocolSteps)}
        </td>
      </tr>);
      index++;
         }
            if (childGraft.targets && childGraft.targets.length > 0)
            {
                for (let targetIndex = 0; targetIndex < childGraft.targets.length; targetIndex++) {
                    const targetGraft = childGraft.targets[targetIndex];
                    this.recurseAddingBoxes(targetGraft, targetIndex + index, currentConduit, protocolSteps);
                }
            }
    }

    render() {
       
this.graftBoxes = [];

let protocolSteps: string[] = this.props.protocolSteps;
//Loop through measurements in procedure and get unique performedProcedureSteps for those assigned to this graft.
// for (let index = 0; index < this.props.parentProcedure?.measurements.length; index++) {
//     const element = this.props.parentProcedure?.measurements[index];

//     if (element.performedProcedureStep as string)
//     {
//         if (protocolSteps.indexOf(element.performedProcedureStep as string) === -1)
//         {
//             protocolSteps.push(element.performedProcedureStep as string);
//         }
//     }
// }

this.recurseAddingBoxes(this.props.CurrentItem, 0, "", protocolSteps);

return ( <>
    <div 
    id={this.props.CurrentItem.id}
        className={"visual-row-container " }>
       <div className={"plain-container " + this.props.CurrentItem.type + " " + (this.props.CurrentItem.type === "Target" ? "other-cardiac-target" : "")}> 
        {(this.props.showeditbutton && this.props.CurrentItem.type !== "PreGraft")  &&
        <button className='intuiButton iconButton editButton' onClick={()=>
            {
                if (this.props.parentProcedure && this.props.editGraftClicked)   
                    this.props.editGraftClicked( "", this.props.parentProcedure.id, this.props.CurrentItem.id as string);
            }
            }>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M31.5156 5.14062C31.5156 5.89062 31.375 6.61979 31.0938 7.32812C30.8125 8.02604 30.4062 8.64062 29.875 9.17188L9.90625 29.1406C9.78125 29.2656 9.63542 29.3698 9.46875 29.4531C9.3125 29.5365 9.14583 29.6042 8.96875 29.6562L1.23438 31.5938C1.13021 31.6146 1.05208 31.625 1 31.625C0.729167 31.625 0.494792 31.5312 0.296875 31.3438C0.0989583 31.1458 0 30.9115 0 30.6406C0 30.5781 0.0104167 30.4948 0.03125 30.3906L1.96875 22.6562C2.02083 22.4792 2.08854 22.3125 2.17188 22.1562C2.25521 21.9896 2.35938 21.8438 2.48438 21.7188L22.6719 1.53125C23.1615 1.04167 23.7292 0.666667 24.375 0.40625C25.0312 0.135417 25.7031 0 26.3906 0C27.1094 0 27.7812 0.135417 28.4062 0.40625C29.0312 0.666667 29.5729 1.03125 30.0312 1.5C30.5 1.95833 30.8646 2.5 31.125 3.125C31.3854 3.75 31.5156 4.42188 31.5156 5.14062ZM29.5156 5.20312C29.5156 4.75521 29.4375 4.33854 29.2812 3.95312C29.1354 3.55729 28.9219 3.21354 28.6406 2.92188C28.3698 2.63021 28.0417 2.40625 27.6562 2.25C27.2708 2.08333 26.849 2 26.3906 2C25.9948 2 25.6458 2.05729 25.3438 2.17188C25.0417 2.27604 24.7604 2.42188 24.5 2.60938C24.25 2.79688 24.0104 3.01042 23.7812 3.25C23.5521 3.48958 23.3073 3.73958 23.0469 4L27.625 8.57812C27.8854 8.32812 28.1302 8.08333 28.3594 7.84375C28.5885 7.60417 28.7865 7.35417 28.9531 7.09375C29.1302 6.83333 29.2656 6.55208 29.3594 6.25C29.4635 5.94792 29.5156 5.59896 29.5156 5.20312ZM2.375 29.25L8.48438 27.7188L26.2188 9.98438L21.6406 5.40625L3.90625 23.1406L2.375 29.25Z" fill="black"/>
            </svg>
        </button>
    }
        <table className={"subway "}>
            {this.graftBoxes}
        </table>

        </div>
       
    </div> 
    </>     
    )
}
}

export default CardiacSubwayMap;